import { PageRowSection, ReferanceCard } from "../../components"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "@mui/material"
import { theme } from "../../../../utils/theme/godzilla_light"
import TransMsg from './transMessage'
import EducateToEmpower from "./EducateToEmpower"
import Overlay from '../../../../assets/images/svgs/counsellingPatients/whole_patient_overlay.svg'
import { desktopEdHubReferences, mobileEdHubReferences } from "../../../../assets/data/educationHub/referancesData"

const styles = {
    rowTitle: {
        ...theme.typography.components.sectionTitle,
        fontSize: "20px",
        paddingRight: "10px",
        lineHeight: "26px"
    },
    downloadLabel: {
        ...theme.typography.montseratBodyRegular,
        fontSize: "16px",
        color: "#A62C4E"
    },
    patientImg: {
        height: "271px",
        maxWidth: "464px",
        marginTop: "-26px",
        marginRight: "-88px",
    }
}

const CounsellingPatients = () => {
    const { t } = useTranslation()
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    return (
        <>
            <PageRowSection
                title={t(TransMsg.SEEING_THE_WHOLE_PATIENT)}
                description={t(TransMsg.SEEING_THE_WHOLE_PATIENT_DESCRIPTION)}
                containerBoxSx={{ gap: "70px",px:"31px" }}
                sectionWrapperSx={{ pt: "77px", pb: "78px" }}
                rowImageSource={Overlay}
                rowImageSx={styles.patientImg}
            />
            <EducateToEmpower />
            <ReferanceCard
                referanceData={isMobileX ? mobileEdHubReferences : desktopEdHubReferences}
                wrapperSx={{ py: "27px" }}
            />
        </>
    )
}

export default CounsellingPatients
